"use client";

import { useEffect } from "react";
import { useConversationStore } from "@/modules/conversation/store";

export function DesktopBadgeSync() {
  const unreadCounts = useConversationStore((s) => s.unreadCounts);
  const crossAccountUnread = useConversationStore((s) => s.crossAccountUnread);

  useEffect(() => {
    const electronAPI = (window as any).electronAPI;
    if (!electronAPI?.app?.setBadgeCount) return;
    // Count unread chats in current account
    const currentAccountUnread = Object.values(unreadCounts).filter(
      (count) => (count || 0) > 0,
    ).length;
    // Add cross-account unread
    const otherAccountsUnread = Object.values(crossAccountUnread).reduce(
      (sum, count) => sum + Math.max(0, count || 0), 0,
    );
    electronAPI.app.setBadgeCount(currentAccountUnread + otherAccountsUnread);
  }, [unreadCounts, crossAccountUnread]);

  return null;
}
